import _ from 'lodash';

import { CombinedDocuments, Image } from 'models';
import { isImage } from './entityType';

export function getImageDocuments(documents: CombinedDocuments): Image[] {
  return _.filter<typeof documents, Image>(documents, isImage);
}
